import { onRequest } from "~/interceptors";
import { RoundRobinApiSelector } from "../select-api/select_api";

function parseUrls(url: string) {
  return url.split(";").map((e) => e.replace(/\/+$/, ""));
}

interface AVAIL_METHODS {
  INDEX?: boolean;
  GET?: boolean;
  POST?: boolean;
  UPDATE?: boolean;
  DELETE?: boolean;
  ApiWrite: string;
  ApiRead: string;
  fetch: (url: string, options: any) => Promise<any>;
}

type HTTP_METHODS = "GET" | "POST" | "PUT" | "DELETE";

type options = {
  method: HTTP_METHODS;
  body?: any;
  query?: any;
  params?: any;
  headers?: Headers;
  signal?: AbortSignal;
  onRequest?: (context: any) => void;
};

export default class RestResource {
  private static RestResourceApiWrite: RoundRobinApiSelector;
  private static RestResourceApiRead: RoundRobinApiSelector;
  private static headers: Headers;

  public static initilize() {
    const env = useRuntimeConfig().public;
    const WRITE_BASE_API = parseUrls(env.VUE_APP_ROOT_API_WRITE);
    const READ_BASE_API = parseUrls(env.VUE_APP_ROOT_API);

    RestResource.RestResourceApiWrite = new RoundRobinApiSelector(
      WRITE_BASE_API
    );
    RestResource.RestResourceApiRead = new RoundRobinApiSelector(READ_BASE_API);

    this.setHeader("Content-Type", "application/json");
    this.setHeader("DivasPlay-Server-Version", "V2");
  }

  protected static basePath = "";

  private static mergeHeaders(headers: Headers | undefined) {
    if (!RestResource.headers) RestResource.headers = new Headers();
    if (!headers) return RestResource.headers;

    for (const [key, value] of RestResource.headers.entries()) {
      if (!headers.has(key)) headers.set(key, value);
    }

    return headers;
  }

  static setHeader(key: string, value: string) {
    if (!RestResource.headers) RestResource.headers = new Headers();
    RestResource.headers.set(key, value);
  }

  public static fetch(url: string, options: options): Promise<any> {
    options.headers = this.mergeHeaders(options.headers);
    const aborter = new AbortController();

    const Options = {
      ...options,
      signal: aborter.signal,
      onRequest: (context: any) => onRequest(context, aborter),
    };

    return $fetch(url, Options);
    // return useFetch(url, Options);
  }

  static get ApiWrite() {
    if (!this.RestResourceApiWrite) RestResource.initilize();
    return RestResource.RestResourceApiWrite.get() + this.basePath;
  }

  static get ApiRead() {
    if (!this.RestResourceApiRead) RestResource.initilize();
    return RestResource.RestResourceApiRead.get() + this.basePath;
  }

  static index(this: AVAIL_METHODS, params: any, headers?: Headers) {
    if (!this.INDEX) throw new Error("INDEX not implemented");
    return this.fetch(this.ApiRead, { method: "GET", query: params, headers });
  }

  static get(
    this: AVAIL_METHODS,
    params: { id: string | number },
    headers?: Headers
  ) {
    if (!this.GET) throw new Error("GET not implemented");
    return this.fetch(`${this.ApiRead}/${params.id}`, {
      method: "GET",
      query: params,
      headers,
    });
  }

  static store(this: AVAIL_METHODS, params: any, headers?: Headers) {
    if (!this.POST) throw new Error("STORE not implemented");
    return this.fetch(this.ApiWrite, { method: "POST", body: params, headers });
  }

  static update(
    this: AVAIL_METHODS,
    params: { id: string | number },
    headers?: Headers
  ) {
    if (!this.UPDATE) throw new Error("UPDATE not implemented");
    return this.fetch(`${this.ApiWrite}/${params.id}`, {
      method: "PUT",
      body: params,
      headers,
    });
  }

  static delete(
    this: AVAIL_METHODS,
    params: { id: string | number },
    headers?: Headers
  ) {
    if (!this.DELETE) throw new Error("DELETE not implemented");
    return this.fetch(`${this.ApiWrite}/${params.id}`, {
      method: "DELETE",
      body: params,
      headers,
    });
  }
}
